import { render } from "./SearchHash.vue?vue&type=template&id=065b63fd"
import script from "./SearchHash.vue?vue&type=script&lang=js"
export * from "./SearchHash.vue?vue&type=script&lang=js"
script.render = render

export default script